import Hidden from '@material-ui/core/Hidden';
import React, { FunctionComponent } from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import { Layout } from '../components';
import {
  BlogPostSection,
  KeyFeaturesSection,
  LandingSection,
  OperatingCitiesSection,
  PartnerSection,
  SecondHypeSection,
  StatisticsSection,
  TestimonialSection,
} from '../components/home';
import favicon from '../images/treet-favicon.png';
import { canonicalUrl } from '../utils/canonicalUrl';

export type OpeningHoursStatistics = {
  day_of_week: number;
  open_from?: string;
  open_until?: string;
  delivers_from?: string;
  delivers_until?: string;
};

export type PharmacyStatistics = {
  name: string;
  slug?: string;
  city: string;
  url?: string;
  street_address?: string;
  postal_code?: string;
  phone_number?: string;
  has_webshop: boolean;
  offers_delivery: boolean;
  offers_pickup_box: boolean;
  logo_url?: string;
  opening_hours?: OpeningHoursStatistics[];
};

export type CityStatistics = {
  city: string;
  pharmacies: PharmacyStatistics[];
};

type Props = {
  data: {
    allStatistics: {
      nodes: Array<{
        pharmacists: number;
        pharmacies: PharmacyStatistics[];
        cities: CityStatistics[];
      }>;
    };
  };
};

const IndexPage: FunctionComponent<Props> = ({ data }) => {
  const statsNode =
    (data && data.allStatistics && data.allStatistics.nodes && data.allStatistics.nodes[0]) || undefined;
  const pharmacies = (statsNode && statsNode.pharmacies) || [];
  const pharmacists = (statsNode && statsNode.pharmacists) || 0;
  const cities = (statsNode && statsNode.cities) || [];

  return (
    <>
      <Helmet>
        <title>Treet-verkkoapteekki</title>
        <meta
          name="description"
          content="Lähin apteekkisi on netissä. ✓ Tilaa 24/7 ✓ Nopein toimitus ✓ Reseptilääkkeet, apteekkituotteet, kosmetiikka ✓ Treet.fi + Treet-sovellus"
        />
        <link rel="icon" href={favicon} />
        <link rel="canonical" href={canonicalUrl('/')} />
      </Helmet>
      <Layout>
        <LandingSection />
        <KeyFeaturesSection />
        <StatisticsSection pharmacyCount={pharmacies.length} pharmacistCount={pharmacists} />

        <TestimonialSection />

        <Hidden xsUp>
          <OperatingCitiesSection cities={cities.map(cityStat => cityStat.city)} />
        </Hidden>

        <Hidden xsUp>
          <SecondHypeSection />
        </Hidden>
        <BlogPostSection />
        <Hidden xsDown>
          <PartnerSection />
        </Hidden>
      </Layout>
    </>
  );
};

IndexPage.displayName = 'IndexPage';

export default IndexPage;

export const query = graphql`
  query IndexStatisticsQuery {
    allStatistics {
      nodes {
        pharmacists
        pharmacies {
          name
          slug
          city
          url
          street_address
          postal_code
          phone_number
          has_webshop
          offers_delivery
          offers_pickup_box
          logo_url
          opening_hours {
            day_of_week
            open_from
            open_until
            delivers_from
            delivers_until
          }
        }
        cities {
          city
          pharmacies {
            name
            url
          }
        }
      }
    }
  }
`;
